import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submitWithIgnorePostcodeMismatch() {
    const form = this.element.closest("form");
    if (form) {
      const input = document.createElement("input");
      input.setAttribute("name", "ignore_postcode_mismatch");
      input.setAttribute("type", "hidden");
      input.setAttribute("value", "true");
      form.prepend(input);
      form.submit();
    }
  }
}
